import { createContext } from 'react'

export interface StaticResult {
  status: number
  origin: string
}

export const StaticContext = createContext<StaticResult | null>(null)